import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Flyout } from '@els/els-react--flyout';
import ResultTracking from '@Services/ResultTracking';
import SubstanceDetailsModal from '@Components/Results/structure/substance-details/SubstanceDetailsModal';
import HoverTooltip from '@Components/HoverTooltip';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';

import './SubstanceDetails.scss';

export default class SubstanceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  toggleDetails(isOpen) {
    const { trackingContext, trackingContent, tooltipId } = this.props;
    this.setState({ isOpen });
    if (isOpen) {
      ResultTracking.structureContentInteraction('view details', trackingContext, trackingContent);
      const tooltip = document.getElementById(tooltipId);
      if (tooltip) {
        tooltip.dispatchEvent(
          new MouseEvent('mouseleave', {
            bubbles: true,
          })
        );
      }
    }
  }

  render() {
    const { tooltipId, metadata, tooltipPlace, structure, reactionId } = this.props;
    const { isOpen } = this.state;
    const tooltipLabel = 'View Details';
    return (
      <Flyout
        flyout={
          <SubstanceDetailsModal isOpen={isOpen} structure={structure} reactionId={reactionId} closeMenu={noop} metadata={metadata} />
        }
        shouldCloseOnESC
        showCloseButton
        onToggle={this.toggleDetails}
        placement="bottom-end"
        pointerType="primary">
        <HoverTooltip id={tooltipId} tooltip={tooltipLabel} tooltipPlace={tooltipPlace} theme="simple">
          <button
            type="button"
            aria-label="View details"
            onClick={this.toggleDetails}
            title={tooltipId ? null : tooltipLabel}
            className="els-btn els-btn-link els-btn-sm e2e-dropdown e2e-details structure-details-button">
            <svg className="els-btn-icon els-btn-icon-sm" focusable="false">
              <use xlinkHref="#icon-structure-details" />
            </svg>
            <span className="screen-reader-text">View details</span>
          </button>
        </HoverTooltip>
      </Flyout>
    );
  }
}

SubstanceDetails.propTypes = {
  trackingContext: PropTypes.string,
  structure: PropTypes.object.isRequired,
  reactionId: PropTypes.string,
  tooltipId: PropTypes.string,
  metadata: MetadataPropTypesShape,
  tooltipPlace: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  trackingContent: PropTypes.array,
};
